import type {
  DailyStatsRequest,
  DailyStatsRow,
} from "@adlywise/shared";

export type AnalyticsDateRange = {
  startDate: Date;
  endDate: Date;
};

export type AnalyticsPreset = "today" | "last7Days";

export type AnalyticsDailyStatsRequest = DailyStatsRequest;
export type AnalyticsDailyStatsRow = DailyStatsRow;

export type AnalyticsFilters = {
  country: string[];
  region: string[];
  city: string[];
  platform: string[];
  deviceType: number[];
  channelId: number[];
  campaignUuid: string[];
  kind: number[];
  categories: string[];
};

export type AnalyticsCampaignOption = {
  uuid: string;
  name: string;
};

export type AnalyticsChannelOption = {
  id: number;
  name: string;
  kind: "static" | "dynamic" | "overlay" | "banner";
  type: "free" | "paid";
};

export type AnalyticsCategoryOption = {
  id: string;
  name: string;
};

export const EMPTY_ANALYTICS_FILTERS: AnalyticsFilters = {
  country: [],
  region: [],
  city: [],
  platform: [],
  deviceType: [],
  channelId: [],
  campaignUuid: [],
  kind: [],
  categories: [],
};
